import { asAmount, Currency, Money } from "@goodfill/domain-properties";
import { z } from "zod";
import { zDecimal } from ".";
import { zCurrency } from "./zodCurrency";

export const zAmount = (message: string = "number required") =>
  zDecimal({ errorMessages: { invalid: message } }).transform(asAmount);

export const zMoney = (amountMessage: string = "number required") =>
  z.object({
    amount: zAmount(amountMessage),
    currency: zCurrency,
  });

export const zNumberAsMoney = (currency: Currency, message: string = "number required") =>
  zAmount(message).transform((amount): Money => ({ amount, currency }));
